export const INSURANCE_LIST = [
  `32 BJ`,
  `3M Dental Services`,
  `AARP Dental Insurance Plan`,
  `AFLAC OF GA`,
  `AFLAC OF NY`,
  `ASURIS NORTHWEST HEALTH`,
  `Administrative Services Only (ASO)`,
  `Advantica`,
  `Aetna`,
  `Affinity Health Plan`,
  `Aliera Health Care`,
  `Allegiance Benefit Plan Management, Inc.`,
  `Altus Dental`,
  `Amerigroup - WA Medicare`,
  `Amerigroup of Georgia`,
  `Ameritas Life Insurance Corp.`,
  `Ameritas Life Insurance Corp. of New York`,
  `Anthem`,
  `BCBS - Alaska`,
  `BCBS - Maryland / CareFirst`,
  `BCBS - Washington`,
  `BCBS - Washington DC`,
  `BCBS OF DE`,
  `BCBS OF MO`,
  `Benefit Inc`,
  `Blue Advantage`,
  `Blue Care Family Plan`,
  `Blue Cross Blue Shield of Alabama`,
  `Blue Cross Blue Shield of Arizona`,
  `Blue Cross Blue Shield of Arkansas`,
  `Blue Cross Blue Shield of Colorado - Anthem`,
  `Blue Cross Blue Shield of Connecticut - Anthem`,
  `Blue Cross Blue Shield of Delaware (UCCI)`,
  `Blue Cross Blue Shield of Georgia - Anthem`,
  `Blue Cross Blue Shield of Illinois`,
  `Blue Cross Blue Shield of Indiana - Anthem`,
  `Blue Cross Blue Shield of Kansas`,
  `Blue Cross Blue Shield of Kansas City (MO)`,
  `Blue Cross Blue Shield of Kentucky - Anthem`,
  `Blue Cross Blue Shield of Louisiana Advantage Plus Network`,
  `Blue Cross Blue Shield of Maine - Anthem`,
  `Blue Cross Blue Shield of Massachusetts`,
  `Blue Cross Blue Shield of Michigan`,
  `Blue Cross Blue Shield of Montana`,
  `Blue Cross Blue Shield of Nevada - Anthem`,
  `Blue Cross Blue Shield of New Hampshire - Anthem`,
  `Blue Cross Blue Shield of New Mexico`,
  `Blue Cross Blue Shield of North Dakota`,
  `Blue Cross Blue Shield of Ohio - Anthem`,
  `Blue Cross Blue Shield of Oklahoma`,
  `Blue Cross Blue Shield of Oregon/ Regence`,
  `Blue Cross Blue Shield of Rhode Island`,
  `Blue Cross Blue Shield of South Carolina`,
  `Blue Cross Blue Shield of South Carolina (FEP)`,
  `Blue Cross Blue Shield of Tennessee`,
  `Blue Cross Blue Shield of Texas`,
  `Blue Cross Blue Shield of Virginia - Anthem`,
  `Blue Cross Blue Shield of Wisconsin`,
  `Blue Cross Blue Shield of Wisconsin FEP - Anthem`,
  `Blue Cross Blue Shield of Wyoming`,
  `Blue Cross of California - Anthem`,
  `Blue Shield of California`,
  `Blue Shield of California Federal Plan`,
  `Blue Shield of Idaho / Regence`,
  `Blue Shield of Pennsylvania`,
  `Blue Shield of Washington / Regence of Washington Health`,
  `CIGNA`,
  `CIGNA International`,
  `Cigna Select (Formerly known as Great West)`,
  `CompBenefits and Humana Specialty Benefits`,
  `Connecticut General (CIGNA)`,
  `DDIC`,
  `DELTA DENTAL OF AR`,
  `DELTA DENTAL OF AZ`,
  `DELTA DENTAL OF IA`,
  `DELTA DENTAL OF ID`,
  `DELTA DENTAL OF KS`,
  `DELTA DENTAL OF MA`,
  `DELTA DENTAL OF WI`,
  `DENTI-CAL (MEDICAID OF CA)`,
  `DENTIST DIRECT`,
  `Decare Dental Health International (DDHI)`,
  `Delta Dental (Northeast - ME, NH, and VT)`,
  `Delta Dental - Tricare Retiree`,
  `Delta Dental Ins. Co. - Alabama`,
  `Delta Dental Ins. Co. - Florida`,
  `Delta Dental Ins. Co. - Georgia`,
  `Delta Dental Ins. Co. - Louisiana`,
  `Delta Dental Ins. Co. - Mississippi`,
  `Delta Dental Ins. Co. - Montana`,
  `Delta Dental Ins. Co. - Nevada`,
  `Delta Dental Ins. Co. - Texas`,
  `Delta Dental Ins. Co. - Utah`,
  `Delta Dental of California`,
  `Delta Dental of Colorado`,
  `Delta Dental of Connecticut`,
  `Delta Dental of Delaware`,
  `Delta Dental of Illinois Group Plans`,
  `Delta Dental of Indiana`,
  `Delta Dental of Iowa - Government Programs`,
  `Delta Dental of Kentucky`,
  `Delta Dental of Maryland`,
  `Delta Dental of Michigan`,
  `Delta Dental of Minnesota`,
  `Delta Dental of Missouri`,
  `Delta Dental of Nebraska`,
  `Delta Dental of New Jersey`,
  `Delta Dental of New Mexico`,
  `Delta Dental of New York`,
  `Delta Dental of North Carolina`,
  `Delta Dental of North Dakota`,
  `Delta Dental of Ohio`,
  `Delta Dental of Oklahoma`,
  `Delta Dental of Pennsylvania`,
  `Delta Dental of Puerto Rico`,
  `Delta Dental of Rhode Island`,
  `Delta Dental of South Carolina`,
  `Delta Dental of Tennessee`,
  `Delta Dental of Virginia`,
  `Delta Dental of Washington`,
  `Delta Dental of Washington DC`,
  `Delta Dental of West Virginia`,
  `DeltaCare USA - Encounters`,
  `DeltaCare USA / Private Medical Care (Claims)`,
  `DentaQuest - Government`,
  `DentaQuest - Medicaid`,
  `Dental Guard Preferred`,
  `Deseret Mutual Benefit Administrators (DMBA)`,
  `Direct Dental Administrators, Inc.`,
  `Everence`,
  `FLEX COMPENSATION`,
  `First Reliance Standard`,
  `Florida Combined Life (Dental)`,
  `GEHA EMPLOYEE PROGRAM`,
  `GROUP DENTAL SERVICE`,
  `Golden West Dental`,
  `Guardian Life Insurance Co. of America`,
  `HDS Medicaid`,
  `HEALTH CHOICE AZ`,
  `HEALTHPLEX`,
  `HMSA (HAWAII MEDICAL SERVICES) - COMMERCIAL`,
  `Hawaii Dental Service`,
  `HealthChoice Oklahoma`,
  `HealthScope Benefits`,
  `HealthScope Benefits (Tribute Health Plan)`,
  `HealthScope Benefits / EHC Repricing`,
  `HealthScope Benefits/ Morris Associates`,
  `Healthcare Highways`,
  `Healthsource Provident`,
  `Hershey Healthsmile`,
  `Humana`,
  `Humana CompBenefits Federal Plan Dental`,
  `Humana Specialty Benefits Florida Healthy Kids Dental`,
  `Humana Specialty Benefits State of Florida Dental`,
  `Indiana/Kentucky/Ohio Regional Council of Carpenters Welfare Fund`,
  `International Brotherhood of Electrical Workers (IBEW), Local 38 Health & Welfare Fund`,
  `KAISER PERMANENTE`,
  `Lincoln Financial`,
  `MASS HEALTH (MEDICAID OF MA)`,
  `MEDICA PUBLIC PROGRAMS`,
  `MEDICAID - COLORADO`,
  `MEDICAID - IDAHO`,
  `MEDICAID - KENTUCKY (REGION 3 - DORAL DENTAL)`,
  `MEDICAID - KENTUCKY (REGION 5 - KY HEALTH CHOICE)`,
  `MEDICAID - MARYLAND`,
  `MEDICAID - SOUTH CAROLINA`,
  `MEDICAID - VIRGINIA`,
  `MEDICAID OF AR`,
  `MEDICAID OF FL`,
  `MEDICAID OF IA`,
  `MEDICAID OF KS`,
  `MEDICAID OF ME`,
  `MEDICAID OF MO`,
  `MEDICAID OF MS`,
  `MEDICAID OF MT`,
  `MEDICAID OF NC`,
  `MEDICAID OF ND`,
  `MEDICAID OF NH`,
  `MEDICAID OF NJ`,
  `MEDICAID OF NM`,
  `MEDICAID OF NV`,
  `MEDICAID OF OH`,
  `MEDICAID OF OK`,
  `MEDICAID OF OR`,
  `MEDICAID OF PA`,
  `MEDICAID OF TX`,
  `MEDICAID OF VT`,
  `MEDICAID OF WI`,
  `MEDICAID OF WV`,
  `MEDICAID OF WY`,
  `MUTUAL HEALTH SERVICES`,
  `MVP SELECT CARE`,
  `Managed Care of North America, Inc. (MCNA)`,
  `Managed DentalGuard`,
  `Medicaid - Georgia (HFP)`,
  `Medicaid - Illinois`,
  `Medicaid of Alabama`,
  `Medicaid of Connecticut`,
  `Medicaid of Indiana`,
  `Medicaid of Michigan`,
  `Medicaid of Minnesota`,
  `Medicaid of New York`,
  `Medicaid of Tennessee, BlueCare`,
  `Medicaid of Texas - DentaQuest`,
  `Medicaid of Utah`,
  `Medicaid of Virginia, HealthKeepers Plus`,
  `Medicaid of Washington`,
  `Medicaid of Wisconsin - DentaQuest`,
  `Medicaid of Wisconsin, Humana / TDC`,
  `Medicaid of Wisconsin, PrimeCare`,
  `Medical Mutual of Ohio (MMO)`,
  `Mercy Care`,
  `MetLife`,
  `Minnesota Blue Cross Dental (UCCI)`,
  `Molina`,
  `NIPPON LIFE INSURANCE`,
  `North Dakota Dental Service`,
  `Oklahoma DRS Doc`,
  `Pacificare Dental & Vision Plan`,
  `Personal Choice`,
  `Phoenix Health Plans (DentaQuest)`,
  `Physicians Mutual (Dental)`,
  `PrimeCare, Wisconsin State and Federal Employees and Medicaid`,
  `PrimeWest`,
  `Principal`,
  `Public Employee Health Program (PEHP)`,
  `Regence Blue Cross/Blue Shield of Oregon (out of State Providers)`,
  `Reliance Standard Life`,
  `Securian Dental`,
  `SelectHealth`,
  `Skygen USA`,
  `Standard Insurance`,
  `Standard Insurance Co. of New York`,
  `TRUSTMARK`,
  `The Dental Network of Maryland`,
  `Tricare Active Reservists`,
  `Tricare Dental Plan (UCCI)`,
  `Tricare Retiree Dental Program`,
  `Trigon - Blue Cross/Blue Shield of Colorado`,
  `Trigon - Blue Cross/Blue Shield of Virginia`,
  `UFT Welfare Fund`,
  `UMR`,
  `UMR - Harrington`,
  `UMR - LEXINGTON`,
  `UMR - San Antonio`,
  `UMR - Wausau`,
  `UniCare`,
  `United Concordia (Encounters)`,
  `United Concordia - Dental Plus - PA Blue Shield`,
  `United Concordia - Federal Employees Program`,
  `United Concordia - Tricare Dental Plan`,
  `United Concordia Companies, Inc.`,
  `United Healthcare`,
  `United Healthcare Community Plan`,
  `United Medical Resources - Cincinnati`,
  `WILSON MCSHANE CORPORATION`,
  `ZENITH ADMINISTRATORS (MN)`,
]
